import {MentionDTO} from "./MentionDTO";

export default class SuggestionList {

    private list: {
        mention: MentionDTO,
        element: HTMLElement,
        selected: boolean
    }[];

    private command: (props: MentionDTO) => void;

    private selectedIndex: number;

    private root: HTMLElement;

    constructor(list: MentionDTO[], root: HTMLElement, command: (props: MentionDTO) => void) {
        this.root = root;
        this.updateContent(list, command);
    }

    public upHandler(){
        this.setSelectedIndex(this.selectedIndex - 1);
    }

    public downHandler(){
        this.setSelectedIndex(this.selectedIndex + 1);
    }

    public insertMention(){
        let dto = this.list[this.selectedIndex];
        this.command(dto.mention);
    }

    public setSelectedIndex(index: number){
        console.log("SET INDEX", index, "C", this.selectedIndex);
        if(this.list.length <= index){
            return;
        }

        if(index < 0){
            return;
        }

        this.selectedIndex = index;

        console.log("AAA", this.selectedIndex)

        let selected = null;

        for(let i=0; i<this.list.length; i++){

            if(i == index){
                selected = this.list[i].element;
                if(!this.list[i].selected){
                    this.list[i].selected = true;
                    this.list[i].element.classList.add("selected")
                }
            }else{
                if(this.list[i].selected){
                    this.list[i].selected = false;
                    this.list[i].element.classList.remove("selected")
                }
            }

        }

        let selectedBottom = selected.offsetHeight + selected.offsetTop;

        console.log("Bottom" ,selectedBottom, this.root.offsetHeight + this.root.scrollTop)

        if(selectedBottom > this.root.offsetHeight + this.root.scrollTop){
            this.root.scrollTop = selectedBottom - this.root.offsetHeight;
        }

        if(selected.offsetTop < this.root.scrollTop){
            this.root.scrollTop = selected.offsetTop;
        }

    }

    public setSelectedElement(element: HTMLElement){
        for(let i=0; i<this.list.length; i++){
            if(this.list[i].element == element){
                this.setSelectedIndex(i);
                return;
            }
        }
    }


    public clickElement(element: HTMLElement){
        this.setSelectedElement(element);
        this.insertMention();
    }


    public updateContent(list: MentionDTO[], command: (props: MentionDTO) => void): void{
        this.command = command;
        this.list = [];

        if(list.length == 0){
            this.root.innerHTML = "";
            this.root.style.visibility = "hidden";
            return;
        }

        this.root.style.visibility = "visible";

        let fragment = document.createDocumentFragment();

        let i = 0;

        for (const mention of list) {
            let div = document.createElement("div");
            div.innerHTML = mention.label;
            fragment.append(div);

            this.list.push({
                mention: mention,
                element: div,
                selected: false
            });

            div.addEventListener('mouseenter', (e) => {
                this.setSelectedElement(div);
            });

            div.addEventListener('click', (ev) => {
                this.clickElement(div);
            })

            i++;

        }

        this.root.innerHTML = "";
        this.root.appendChild(fragment);



        this.setSelectedIndex(0);
    }

}